// import Vue from 'vue';
// import Vuex from 'vuex';
import { createStore } from 'vuex'
import user from './user'
import utilities from './utilities'
import chat from './chat'
import report from './report'
import wallet from './wallet'
import payment from './payment'
import referral from './referral'
import customerReview from './customerReview'
import newsletter from './newsletter'
import blog from './blog'
import quotation from './quotation'
import surcharge from "./surcharge"
import vehicle from "./vehicle"
import maintenance from "./maintenance"
import sparePartRequest from "./sparePartRequest"
import subscription from "./subscription"

import admin from './admin'

// Vue.use(Vuex);

export default createStore({
  modules: {
    user, utilities, chat, report, wallet, payment, referral, customerReview, newsletter, blog, quotation, surcharge,
    vehicle, maintenance, sparePartRequest, subscription, admin
  },
  state: {
  },
  mutations: {
  },
  actions: {
  },
  // plugins: [createPersistedState()]
});
